// src/mixins/ChatInactivityMixin.js
export default {
  data() {
    return {
      inactivityTimeout: null,
      chatEndTimeout: null,
      currentMessageIndex: 0,
      chatStarted: false,
      waitingChatbotToReply: false
    }
  },
  computed: {
    inactivityMessages() {
      return (this.$store.state && this.$store.state.campaign && this.$store.state.campaign.chat_inactivity_messages) || []
    }
  },
  methods: {
    resetTimer() {
      this.clearTimers()
      this.waitingChatbotToReply = false
      this.currentMessageIndex = 0
      this.scheduleNextMessage()
    },
    handleUserActivity() {
      this.clearTimers()
      if (this.chatStarted && !this.waitingChatbotToReply) {
        const chatMessages = JSON.parse(localStorage.getItem('chat')) || []
        if (chatMessages.length >= 6) {
          const lastInactivityMessageIndex = this.inactivityMessages.findIndex((inactivityMessage) => {
            return chatMessages[chatMessages.length - 1].text.indexOf(inactivityMessage.message) > -1
          })
          this.currentMessageIndex = Math.max(0, lastInactivityMessageIndex + 1)
          if (this.currentMessageIndex < this.inactivityMessages.length) {
            this.scheduleNextMessage()
          }
        }
      }
    },
    scheduleNextMessage() {
      const $this = this
      if (this.chatStarted && this.inactivityMessages && this.inactivityMessages.length > 0) {
        const chatMessages = JSON.parse(localStorage.getItem('chat')) || []
        if (chatMessages.length >= 6) {
          if (this.currentMessageIndex < this.inactivityMessages.length) {
            const inactivityMessage = this.inactivityMessages[this.currentMessageIndex]
            this.inactivityTimeout = setTimeout(() => {
              $this.$root.$emit('inactivity-message', inactivityMessage.message)
              $this.clearTimers()
              $this.currentMessageIndex++
              $this.scheduleNextMessage()
            }, inactivityMessage.duration * 1000)
          } else if (this.currentMessageIndex === this.inactivityMessages.length && !this.chatEndTimeout) {
            this.chatEndTimeout = setTimeout(() => {
              $this.$root.$emit('chat-ended')
              $this.clearTimers()
              $this.waitingChatbotToReply = false
              $this.currentMessageIndex = 0
            }, 10000)
          }
        }
      }
    },
    clearTimers() {
      clearTimeout(this.inactivityTimeout)
      clearTimeout(this.chatEndTimeout)
      this.inactivityTimeout = null
      this.chatEndTimeout = null
    },
    addListeners() {
      if (!window.hasChatInactivityHandler) {
        window.addEventListener('mousemove', window.hasChatInactivityHandler = this.handleUserActivity)
        window.addEventListener('keypress', this.handleUserActivity)
        window.addEventListener('touchstart', this.handleUserActivity)

        this.$root.$on('chat-started', (chatStatus) => {
          this.chatStarted = chatStatus
          this.handleUserActivity()
        })
        this.$root.$on('user-replied', () => {
          this.clearTimers()
          this.waitingChatbotToReply = true
        })
        this.$root.$on('chatbot-replied', () => {
          setTimeout(() => {
            this.resetTimer()
          }, 500)
        })
      }
    },
    removeListeners() {
      if (window.hasChatInactivityHandler) {
        window.removeEventListener('mousemove', this.handleUserActivity)
        window.removeEventListener('keypress', this.handleUserActivity)
        window.removeEventListener('touchstart', this.handleUserActivity)
        window.hasChatInactivityHandler = false
        this.$root.$off('chat-started')
        this.$root.$off('user-replied')
        this.$root.$off('chatbot-replied')
      }
    }
  },
  mounted() {
    this.addListeners()
  },
  beforeDestroy() {
    this.clearTimers()
    this.removeListeners()
  }
}
